export const titles = {
    flterBy: 'Filter By',
    salesOrder: 'Sales Order',
}

export const fields = {
    customer: {
        title: 'Customer',
        placeholder: 'Select Customer'
    },
    branch: {
        title: 'Branch',
        placeholder: 'Select Branch'
    }
}

export const buttons = {
    applyFilter: 'Apply Filter',
    reset: 'Reset'
}

export const headers = {
    soNumber: 'SO No.',
    soDate: 'SO Date',
    lrNumber: 'LR Number',
    lrDate: 'LR Date',
    refNo: 'Reference No.',
    customerName: 'Customer Name',
    amount: 'Amount',
    branch: 'Branch',
    vehicle: 'Vehicle',
    remarks: 'Remarks',
    createdOn: 'Created On',
    createdBy: 'Created By',
    modifiedOn: 'Modified On',
    modifiedBy: 'Modified By',
    edit: 'Edit/Delete'
}